import type { EntityConfigDefinition } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'CONFIG_PARAM',
  idField: 'CONFIG_PARAM_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  fieldsToRemove: [],
  
  // Environment copy configuration
  preserveOnCopy: ['CONFIG_PARAM_ID'],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['CONFIG_NAME'],
    comparisonFields: ['CONFIG_NAME', 'CONFIG_VALUE', 'DESCRIPTION'],
    stringMatchFields: ['CONFIG_NAME'],
    stringMatchThreshold: 0.50,
    displayFields: ['CONFIG_PARAM_ID', 'CONFIG_NAME', 'CONFIG_VALUE', 'DESCRIPTION', 'CREATED_DATE', 'CHANGED_DATE']
  },
  
  // Fields configuration
  fields: [
    "CONFIG_PARAM_ID",
    "CONFIG_NAME",
    "CONFIG_VALUE",
    "DESCRIPTION",
    "CREATED_DATE",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "CONFIG_NAME",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "CONFIG_VALUE",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "DESCRIPTION",
      "type": "text",
      "required": false,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    },
    {
      "name": "CHANGED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

